import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

import { Text } from "@/features/common/components/tailwind/Text";
import { View } from "@/features/common/components/tailwind/View";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "rgba(0,0,0,0.3)",
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10,
    },
  }),
);

interface OwnerIndicatorProps {
  isPublicContent: boolean;
}

export const OwnerIndicator: FC<OwnerIndicatorProps> = (props) => {
  const { isPublicContent } = props;
  const classes = useStyles();
  const { t } = useTranslation("post");

  if (isPublicContent) return null;

  return (
    <View className={classes.root}>
      <View className="flex flex-col items-center">
        <Text size="normal" className="text-white font-bold mb-4">
          {t("post:imageCard.myPost")}
        </Text>
      </View>
    </View>
  );
};
